import { PagePlatformSettings } from '~/app/pages/Platform/Settings';

export const PagePlatformEdit = PagePlatformSettings;
